import axios from 'axios';
import { shippingApi } from '../../api/shipping';
import {
  GET_SHIPPING_REVIEW_DATA_SUCCESS,
  SET_SHIPPING_ITEM_COUNTS,
  UPDATE_SHIPPING_REVIEW_DATA_SUCCESS,
  GET_ARTA_SUBTYPES_SUCCESS,
  SET_SESSION_TITLE,
  RESET_SHIPPING_REVIEW_DATA,
  IS_SHIPPING_REVIEW_DATA_LOADING
} from './reducer';
import { awsServer } from '../../utilities/UrlPaths';

export const resetShippingReviewData = () => (dispatch) => {
  dispatch({ type: RESET_SHIPPING_REVIEW_DATA });
};

export const getShippingReviewData = (catalogID, houseID) => async (dispatch) => {
  dispatch({
    type: IS_SHIPPING_REVIEW_DATA_LOADING,
    payload: true,
  });
  try {
    await shippingApi.postShippingReview(catalogID);
    const NO_IMAGE = `${awsServer}/static/NoImage_140x140.png`;
    const response = await axios.get(`/cps/app/catalog/${catalogID}/summary`);
    const catalogRef = response.data.data.sessionDefinition.catalogRef;
    const sessionTitle = response.data.data.sessionDefinition.title;

    const shippingRes = await shippingApi.fetchReviews(catalogRef, houseID);
    const imageUrlsRes = await axios.get(`/cps/app/catalog/${catalogID}/house/${houseID}/primary-imageurls`);

    const deletedLots = response.data.data.deletedlots || [];
    const lotData = response.data.data.lots;
    const lotCount = response.data.data.lotcount;
    const shippingData = shippingRes?.data?.reviews;
    const ImgUrlsObject = imageUrlsRes.data.data;
    const imageUrlKeys = Object.keys(imageUrlsRes.data.data);
    let readyToConfirmCount = 0;
    let needsReviewCount = 0;
    let inProgressCount = 0;

    const nonDeletedLotsWithShippingData = lotData.reduce((acc, lot, index) => {
      // skip deleted lots
      if (deletedLots.includes(lot.lotNumber)) return acc;

      const lotShippingReviewID = lot.shippingReviewID;
      const shippingDataOfLot = shippingData.find((ship) => ship.id === lotShippingReviewID);
      if (shippingDataOfLot) {
        lot.shippingReviewData = shippingDataOfLot;
        if (lot.shippingReviewData.status === 'awaiting_approval') {
          readyToConfirmCount += 1;
        } else if (lot.shippingReviewData.status === 'failed') {
          needsReviewCount += 1;
        } else if (lot.shippingReviewData.status === 'pending') {
          inProgressCount += 1;
        }
      }
      const imageUrl = imageUrlKeys.find((imageLotNumber) => imageLotNumber === lot.lotNumber);
      if (imageUrl) {
        lotData[index].imageUrl = ImgUrlsObject[imageUrl];
      } else {
        lotData[index].imageUrl = NO_IMAGE;
      }
      acc.push(lot);
      return acc;
    }, []);

    dispatch({
      type: GET_SHIPPING_REVIEW_DATA_SUCCESS,
      payload: nonDeletedLotsWithShippingData,
    });

    dispatch({
      type: SET_SHIPPING_ITEM_COUNTS,
      payload: {
        shippingItemCountAll: lotCount,
        readyToConfirmCount,
        needsReviewCount,
        inProgressCount,
      },
    });
    dispatch({
      type: SET_SESSION_TITLE,
      payload: sessionTitle,
    });
  } catch (error) {
    console.log('error', error);
  } finally {
    dispatch({
      type: IS_SHIPPING_REVIEW_DATA_LOADING,
      payload: false,
    });
  }
};
export const updateReviewStatus = (lotId, review) => (dispatch, getState) => {
  let readyToConfirmCountChange = 0;
  let needsReviewCountChange = 0;
  let inProgressCountChange = 0;

  const updatedLotsWithShippingData = getState().shippingReview.lotsWithShippingData.map((lot) => {
    if (lot.shippingReviewID === review.id) {
      const transition = `${lot.shippingReviewData.status}->${review.status}`;
      switch (transition) {
        // transition from 'pending' to 'completed' does not affect item counts
        case 'pending->awaiting_approval':
          readyToConfirmCountChange += 1;
          inProgressCountChange -= 1;
          break;
        case 'pending->failed':
          needsReviewCountChange += 1;
          inProgressCountChange -= 1;
          break;
        case 'awaiting_approval->pending':
          readyToConfirmCountChange -= 1;
          inProgressCountChange += 1;
          break;
        case 'failed->pending':
          needsReviewCountChange -= 1;
          inProgressCountChange += 1;
          break;
        case 'awaiting_approval->completed':
          readyToConfirmCountChange -= 1;
          break;
        default:
          break;
      }
      return {
        ...lot,
        shippingReviewData: review
      };
    }
    return lot;
  });
  dispatch({
    type: UPDATE_SHIPPING_REVIEW_DATA_SUCCESS,
    payload: {
      lotsWithShippingData: updatedLotsWithShippingData,
      readyToConfirmCountChange,
      needsReviewCountChange,
      inProgressCountChange
    }
  });
};

export const updateShippingReviewData = (lotId, reviewID, houseID, payload) => async (dispatch) => {
  try {
    const response = await shippingApi.putShippingReview(reviewID, houseID, payload);
    const updatedReview = response.data.review;
    dispatch(updateReviewStatus(lotId, updatedReview));
  } catch (error) {
    console.error('Error updating shipping review data:', error);
  }
};

export const getArtaSubtypes = (abortSignal) => async (dispatch) => {
  try {
    const data = await shippingApi.fetchArtaSubtypes(abortSignal);
    const artaSubtypesMap = data?.reduce((acc, item) => {
      item.subtypes.forEach(subtype => {
        acc[subtype.id] = subtype;
      });
      return acc;
    }, {});

    const orderedListOfArtaSubtypes = data?.reduce((acc, item) => acc.concat(item.subtypes), []).sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    dispatch({
      type: GET_ARTA_SUBTYPES_SUCCESS,
      payload: {
        artaSubtypeMap: artaSubtypesMap,
        artaSubtypeList: orderedListOfArtaSubtypes
      },
    });
  } catch (err) {
    console.error('Error fetching Arta subtypes:', err);
  }
};
